export default __webpack_public_path__ + "static/media/piofaqimage.edfe5aeb.jpg";